import React, { useState, useEffect } from 'react';
import { EditorState, convertFromHTML, ContentState } from 'draft-js';
import Swal from 'sweetalert2';
import Grid from '@mui/material/Grid';
import ButtonAddtag from '../components/EmailManagement/ButtonAddtag';
import TextFieldEmail from '../components/EmailManagement/TextFieldEmail';
import Button from '@mui/material/Button';
import useSubject from '../components/EmailManagement/setUse/useSubject';
import useContentEmail from '../components/EmailManagement/setUse/useContentEmail';
import HtmlEditorEmail from '../components/EmailManagement/HtmlEditorEmail';
import axios from 'axios';
import Container from '@mui/material/Container';
import Loading from '../components/Loading';
export default function EmailManagement() {
  const [isLoading, setIsLoading] = useState(false);
  const [subject, validSubject, setSubject] = useSubject('');
  const [content, validContent, setContent] = useContentEmail('');
  const [editeState, setEditeState] = useState(null);
  const customSwalClass = {
    container: 'swal-z-index',
  };
  const methos = {
    validateData: async () => {
      let status = true;
      validSubject == true || validContent == true
        ? (status = false)
        : (status = true);
      return { validate: status };
    },
    notify: (title, icon, color) => {
      Swal.fire({
        title: title,
        icon: icon,
        confirmButtonColor: color,
        confirmButtonText: 'ตกลง',
        customClass: customSwalClass,
      });
    },
    DefaultDataEditor: async (data) => {
      const initialHtmlContent = data;
      const blocksFromHTML = convertFromHTML(initialHtmlContent);
      const state = EditorState.createWithContent(
        ContentState.createFromBlockArray(
          blocksFromHTML.contentBlocks,
          blocksFromHTML.entityMap,
        ),
      );
      return state;
    },
    getDataEmail: async (check) => {
      try {
        const path = `${process.env.REACT_APP_API_URL}/send-mail/email-template`;
        const data = await axios.get(path, {});
        if (!check) {
          setSubject(data.data.result.subject);
          setContent(data.data.result.textHtml);
          setEditeState(
            await methos.DefaultDataEditor(data.data.result.textHtml),
          );
        } else {
          return { status: data.data.result.status, _id: data.data.result._id };
        }
      } catch (error) {
        throw new Error(error);
      }
    },
    updateData: async (text, _id) => {
      try {
        const path = `${process.env.REACT_APP_API_URL}/send-mail/email-template/${_id}`;
        await axios.put(path, {
          subject: subject,
          textHtml: text,
        });
        await methos.getDataEmail();
      } catch (error) {
        methos.notify('อัพเดตแบบฟอร์มไม่สำเร็จ', 'error', '#a84f4f');
      }
    },
    insertData: async (text) => {
      try {
        const path = `${process.env.REACT_APP_API_URL}/send-mail/email-template`;
        await axios.post(path, {
          subject: subject,
          textHtml: text,
        });
        await methos.getDataEmail();
      } catch (error) {
        methos.notify('อัพเดตแบบฟอร์มไม่สำเร็จ', 'error', '#a84f4f');
      }
    },
    saveEmailForm: async () => {
      try {
        const lines = content.split('\n');
        const result = lines.map((line) => line.trim()).join('');
        const { validate } = await methos.validateData();
        if (!validate) {
          methos.notify('กรุณากรอกข้อมูลให้ครบถ้วน', 'error', '#a84f4f');
          return;
        }
        setIsLoading(true);
        const { status, _id } = await methos.getDataEmail(true);
        status == true
          ? await methos.updateData(result, _id)
          : await methos.insertData(result);
        methos.notify('อัพเดตแบบฟอร์มสำเร็จ', 'success', '#4FA893');
        setIsLoading(false);
      } catch (error) {
        methos.notify('อัพเดตแบบฟอร์มสำเร็จ', 'success', '#4FA893');
      }
    },
    resetForm: () => {
      setIsLoading(true);
      methos.getDataEmail();
      setIsLoading(false);
    },
  };

  useEffect(() => {
    methos.getDataEmail();
  }, []);

  return (
    <div className="container ml-2">
      <div className="text-lg font-light flex items-center ">
        <div className="py-6 text-xl">การจัดการอีเมล</div>
      </div>
      <Loading isLoading={isLoading} />
      <Container maxWidth="">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <ButtonAddtag
              editeState={editeState}
              setEditeState={setEditeState}
            />
          </Grid>
          <Grid item xs={12}>
            <TextFieldEmail
              subject={subject}
              validSubject={validSubject}
              setSubject={setSubject}
            />
          </Grid>
          <Grid item xs={12}>
            <HtmlEditorEmail
              content={content}
              validContent={validContent}
              setContent={setContent}
              editeState={editeState}
              setEditeState={setEditeState}
            />
          </Grid>
          <Grid item xs={12} sx={{ textAlign: 'right' }}>
            {/* <Button
              onClick={() => methos.resetForm()}
              sx={{ color: 'white' }}
              variant="contained"
              color="primary"
            >
              รีเซ็ตการตั้งค่า
            </Button> */}
            <Button
              onClick={methos.saveEmailForm}
              sx={{ color: 'white', marginLeft: '10px' }}
              variant="contained"
              color="primary"
            >
              บันทึกแบบฟอร์ม
            </Button>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}
